import { Button } from '@ibsys/kit';
import { ChevronLeftIcon } from 'lucide-react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import { cn } from '@/shared/lib';
import { PageContainer } from '@/shared/ui';
import { BehaviorFactorTree } from './BehaviorFactorTree/BehaviorFactorTree';
import { BehaviorFactorCard } from './BehaviorFactorCard/BehaviorFactorCard';

export const BehaviorFactorsPage: FC = () => {
  const { id } = useParams<{ id?: string }>();
  const { t } = useTranslation(['common', 'behaviorFactors']);
  const navigate = useNavigate();

  const handleSelectItem = (itemId: number) => {
    navigate(`/behavior-factors/${itemId}`);
  };

  const handleCreateFactor = () => {
    navigate('/behavior-factors/create');
  };

  const handleCreateSubfactor = (parentId: number) => {
    navigate(`/behavior-factors/create?parentId=${parentId}`);
  };

  const handleBack = () => {
    navigate('/behavior-factors');
  };

  return (
    <PageContainer
      enableScroll={false}
      className="flex flex-col gap-5 h-full w-full mx-auto lg:grid lg:grid-cols-[minmax(280px,400px)_1fr] grid-rows-1"
    >
      {/* Left: Tree — на мобильном скрывается при выбранном элементе */}
      <div className={cn('h-full', id ? 'hidden lg:block' : 'block')}>
        <BehaviorFactorTree
          selectedId={id ? +id : undefined}
          onSelectItem={handleSelectItem}
          onCreateFactor={handleCreateFactor}
        />
      </div>

      {/* Right: Card — на мобильном скрывается при отсутствии выбранного элемента */}
      <div className={cn('flex flex-col h-full', !id ? 'hidden lg:flex' : 'flex')}>
        {id ? (
          <>
            {/* Кнопка "Назад" — только на мобильном */}
            <Button
              variant="ghost"
              size="sm"
              className="lg:hidden mb-3 self-start -ml-2"
              icon={<ChevronLeftIcon className="size-4" />}
              onClick={handleBack}
            >
              {t('common:backToList')}
            </Button>
            <BehaviorFactorCard
              key={id}
              factorId={id}
              onCreateSubfactor={handleCreateSubfactor}
              onSelectItem={handleSelectItem}
            />
          </>
        ) : (
          <div className="flex items-center justify-center w-full h-full">
            <div className="text-muted-foreground">{t('behaviorFactors:selectItem')}</div>
          </div>
        )}
      </div>
    </PageContainer>
  );
};
